import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { TbLogout } from "react-icons/tb";
import { logoutUser } from '../../redux/actions/auth';
import { disconnectWallet } from '../../helpers/authServices';

const Header = ({dispatch, isAuthenticated}) => {
const [showDropdown, setShowDropdown]= useState(false)
    const handleLogout=()=>{
   dispatch(logoutUser())
    }

    const handleDisconnectWallet=()=>{

        disconnectWallet()
    setShowDropdown(false)
    }

    const wallet= localStorage.getItem('wallet')
        
    return (
        <header id="header">
            {/* Navbar */}
            <nav data-aos="zoom-out" data-aos-delay={800} className="navbar navbar-expand">
                <div className="container header">
                    {/* Navbar Brand*/}
                    <Link className="navbar-brand" to="/">
                        <img className="navbar-brand-sticky" src="/img/logo-small.png" alt="sticky brand-logo" />
                    </Link>
                    <div className="ml-auto" />
                    {/* Navbar */}
                    <ul className="navbar-nav items mx-auto">
                        <li className="nav-item dropdown">
                            <Link className="nav-link" to="/">Home</Link>
                        </li>
                    

                        <li className="nav-item">
                            <Link to="/contact" className="nav-link">Contact</Link>
                        </li>

                        {isAuthenticated&&   <li className="nav-item">
                            <Link to="/dashboard/addproject" className="nav-link">Add Project</Link>
                        </li>}
                        
                        {isAuthenticated&&   <li className="nav-item">
                            <Link to="/dashboard/manageproject" className="nav-link">Manage Project</Link>
                        </li>}
                        {isAuthenticated&&   <li className="nav-item">
                            <Link to="/dashboard/managereview" className="nav-link">Manage Review</Link>
                        </li>}
                        {!isAuthenticated&& wallet&&  <li className="nav-item">
                            <Link to="/myreview" className="nav-link">Your Review</Link>
                        </li>}
                    </ul>
                    {/* Navbar Icons */}
                    {/* <ul className="navbar-nav icons">
                        <li className="nav-item">
                            <a href="#" className="nav-link" data-toggle="modal" data-target="#search">
                                <i className="fas fa-search" />
                            </a>
                        </li>
                    </ul> */}
                    {/* Navbar Toggler */}
                    <ul className="navbar-nav toggle">
                        <li className="nav-item">
                            <a href="#" className="nav-link" data-toggle="modal" data-target="#menu">
                                <i className="fas fa-bars toggle-icon m-0" />
                            </a>
                        </li>
                    </ul>
                    {/* Navbar Action Button */}
                    <ul className="navbar-nav action d-flex flex-column">
                        {!wallet&& <li className="nav-item ml-3">
                            
                            <Link to="/wallteconnect" className="btn ml-lg-auto btn-bordered-white"><i className="icon-wallet mr-md-2" />Wallet Connect</Link>
                        </li>}

                        {wallet && 
                        <li onClick={()=>setShowDropdown(!showDropdown)} className="nav-item ml-3 wallet-disconnect justify-content-center">
                            
                            <span  className="btn ml-lg-auto btn-bordered-white"><i className="icon-wallet mr-md-2" />{wallet.slice(0,11)+'..'}
       
                            </span>

                            {showDropdown&& <button onClick={handleDisconnectWallet} className="dropdown-div mt-1">
          <span className="text-white" >Wallet Disconnect</span>
          
        </button>}
                        </li>}

                          
                        
                        
                        
                        
                    </ul>

                   

                    {isAuthenticated && <ul className='list-unstyled ml-3'><li onClick={handleLogout} style={{fontSize:'30px', cursor:'pointer'}} className="nav-item">
                    <TbLogout/>
                        </li>
                        </ul>}
                </div>
            </nav>
        </header>
    );
};



function mapStateToProps(state) {
    return {
      isAuthenticated: state.auth.isAuthenticated,

    };
  }

  export default connect(mapStateToProps)(
    Header
  );